define([
	"dojo/_base/declare",
	"csi/xml"
], function(declare,xml) {

	return declare(null, {
		// String: attribute ids for size attributes
		idBaseSize: "BaseSize",

		getCurrentBaseSizeUrl: function(increment) {
			return xml.nodeGetAttributeValue(increment, this.idBaseSize);
		},

		getCurrentSizeRangeUrl: function(increment) {
			return increment.IncrementSizeRange;
		},

		_getIncrement: function(/*Context?*/ctx) {
			var increment = ctx ? ctx.getNode() : this.getNode();
			console.assert(!!increment, "Increment node not found");

			return increment;
		},

		_hasTwoDimSizeRange: function(/*Context*/ctx) {
			var increment = this._getIncrement(ctx);
			var sizeRange = ctx.cache.getNode(increment.IncrementSizeRange);
			return (sizeRange && sizeRange.IsTwoDim);
		}
	});
});